export const galleryImages = [
    {
        id: "gal-01",
        url: "/images/gallery/assam-flood-relief.jpg",
        caption: "",
        alt: ""
    },
    {
        id: "gal-02",
        url: "",
        caption: "",
        alt: ""
    },
    {
        id: "gal-03",
        url: "",
        caption: "",
        alt: ""
    },
    {
        id: "gal-04",
        url: "",
        caption: "",
        alt: ""
    },
    {
        id: "gal-05",
        url: "",
        caption: "",
        alt: ""
    },
    {
        id: "gal-06",
        url: "",
        caption: "",
        alt: ""
    },
    {
        id: "gal-07",
        url: "",
        caption: "",
        alt: ""
    },
    {
        id: "gal-08",
        url: "",
        caption: "",
        alt: ""
    },
    {
        id: "gal-09",
        url: "",
        caption: "",
        alt: ""
    }
]